<nb-card>
	<nb-card-body class="overflow-visible">
		<form [formGroup]="form">
			<div class="form-row">
				<div class="form-input">
					<label class="company-input-label label-row">{{ 'contact-person.contact-person-label' | translate }}</label>
				</div>
			</div>
			<div class="form-row margin-bottom15">
				<div class="form-input">
					<input type="text" name="contact-person-first-name" nbInput [placeholder]="'contact-person.first-name' | translate" formControlName="firstName"
						   autocomplete="user-password" fullWidth>
					@if (isInvalid('firstName')) {
						<div class="validation-message">{{ getValidationErrors('firstName') | async }}</div>
					}
				</div>
				<div class="form-input">
					<input type="text" name="contact-person-last-name" nbInput [placeholder]="'contact-person.last-name' | translate" formControlName="lastName"
						   autocomplete="user-password" fullWidth>
					@if (isInvalid('lastName')) {
						<div class="validation-message">{{ getValidationErrors('lastName') | async }}</div>
					}
				</div>
			</div>

			<div class="form-row">
				<div class="form-input">
					<label class="company-input-label label-row">{{ 'contact-person.job-title-label' | translate }}</label>
				</div>
			</div>
			<div class="form-row margin-bottom15">
				<div class="form-input">
					<input type="text" name="contact-person-job-title" nbInput [placeholder]="'contact-person.job-title-example' | translate" formControlName="jobTitle"
						   autocomplete="user-password" fullWidth>
					@if (isInvalid('jobTitle')) {
						<div class="validation-message">{{ getValidationErrors('jobTitle') | async }}</div>
					}
				</div>
			</div>

			<div class="form-row">
				<div class="form-input margin-bottom15">
					<label class="company-input-label label-row">{{ 'contact-person.email-label' | translate }}</label>
					<input class="contact-person-email-input" type="text" name="contact-person-email" nbInput [placeholder]="'contact-person.email-example' | translate" fullWidth
						   formControlName="email" autocomplete="user-password">
					@if (!showEmailReadOnlyText && showEmailHint) {
						<div class="email-hint">{{ 'contact-person.email-hint' | translate }}</div>
					}
					@if (showEmailReadOnlyText && showEmailHint) {
						<div class="change-email-info">{{ emailHint() | translate }}</div>
					}
					@if (isInvalid('email')) {
						<div class="validation-message">{{ getValidationErrors('email') | async }}</div>
					}
				</div>
			</div>

			<label class="form-row company-input-label label-row">{{ 'contact-person.phone-number-label' | translate }}</label>
			<div class="form-row phone-row">
				<div class="form-input margin-bottom15">
					<div>
						<ng-select id="contact-person-phone-country-code" [disabled]="true" [clearable]="false" [items]="countryCodes" [inputAttrs]="{autocomplete: 'user-password'}"
								   [dropdownPosition]="'bottom'" formControlName="countryCode"></ng-select>
						@if (isInvalid('countryCode')) {
							<div class="validation-message">{{ getValidationErrors('countryCode') | async }}</div>
						}
					</div>
					<div class="phone-number">
						<input type="tel" name="contact-person-phone" nbInput [placeholder]="getPlaceholderKey() | translate" fullWidth
							   formControlName="phone" autocomplete="user-password">
						@if (isInvalid('phone')) {
							<div class="validation-message">{{ getValidationErrors('phone') | async }}</div>
						}
					</div>
				</div>
			</div>

			@if (showSalespeople) {
				<div class="form-row">
					<div class="form-input">
						<div class="label-flex">
							<label class="company-input-label label-row">{{ 'contact-person.salesperson-question' | translate }}</label>
							<span class="float-right optional-label">{{ 'contact-person.optional-label' | translate }}</span>
						</div>
						<div class="checklist">
							<ng-select [items]="salespeople" labelForId="salesperson-select" [clearAllText]="'contact-person.salesperson-clear-text' | translate"
									   [notFoundText]="'common.not-found' | translate"
									   [inputAttrs]="{autocomplete: 'user-password'}" [dropdownPosition]="'bottom'" [placeholder]="'contact-person.salesperson-placeholder' | translate"
									   formControlName="salesperson"></ng-select>
						</div>
					</div>
				</div>
			}
		</form>
	</nb-card-body>
</nb-card>
